export default __webpack_public_path__ + "static/media/excavator.aaa02032.svg";